import React from 'react';

import {
  StdIconsLeft,
  BTIcon,
  StdIcon,
TextMenu 

} from './style';


import { useSelector, useDispatch } from 'react-redux';
import { openMenu } from '@/Redux/slices/menuSlice';

const IconsLeft = () => {
  const dispatch = useDispatch();

  return (
    <>

      <StdIconsLeft >
        <BTIcon onClick={() => dispatch(openMenu())}>
          <StdIcon >
            <svg 
              width="24" height="24" viewBox="0 0 24 24">
              <path d="M0 4h24v2H0zM0 11h14v2H0zM0 18h20v2H0z"></path>
            </svg>
          </StdIcon>
          <TextMenu>
            <span>Menu</span>
          </TextMenu>
        </BTIcon>

      </StdIconsLeft>





    </>
  );
};

export default IconsLeft;
